import axios from "axios";
import type { PositionData } from "../types/position";
import { SERVICEURL } from "../../src/appconfig";

const API_BASE = "/api/positions";
const mytoken = localStorage.getItem("token");

export async function getPositionById(
  id: string | number,
): Promise<PositionData | null> {
  try {
    const mytoken = localStorage.getItem("token");
    const res = await axios.get(
      `${SERVICEURL}api/Position/GetPositionDetail?id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );
    // Pozisyon detayı tek bir nesne olarak dönmeli
    if (res.data && typeof res.data === "object" && !Array.isArray(res.data)) {
      const responseData = res.data.data || res.data;
      
      // Location bilgilerini zenginleştir
      if (responseData.location && Array.isArray(responseData.location)) {
        const enrichedLocation = await Promise.all(
          responseData.location.map(async (loc: any) => {
            const hasTowns =
              Array.isArray(loc.towns) && loc.towns.length > 0;
            const hasTownIds =
              Array.isArray(loc.townIds) && loc.townIds.length > 0;

            if (!loc.cityId) return loc;
            if (hasTowns && loc.cityName) return loc;

            try {
              let cityName = loc.cityName;
              if (!cityName) {
                const cityResponse = await axios.get(
                  `${SERVICEURL}api/Data/GetCityList`,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${mytoken}`,
                    },
                  },
                );

                const city = cityResponse.data?.data?.find(
                  (c: any) => c.id === loc.cityId,
                );
                cityName = city?.name || `Şehir (${loc.cityId})`;
              }

              let towns: any[] = hasTowns ? loc.towns : [];
              if (towns.length === 0 && hasTownIds) {
                const townResponse = await axios.get(
                  `${SERVICEURL}api/Data/GetTownListByCity?cityId=${loc.cityId}`,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${mytoken}`,
                    },
                  },
                );

                const allTowns = townResponse.data?.data || [];
                towns = loc.townIds
                  .map((townId: number) => {
                    const town = allTowns.find((t: any) => t.id === townId);
                    return town
                      ? { townId: town.id, townName: town.name }
                      : null;
                  })
                  .filter(Boolean);
              }

              return {
                ...loc,
                cityName,
                towns,
              };
            } catch (error) {
              console.error("Location bilgisi alınırken hata:", error);
              return loc;
            }
          }),
        );

        responseData.location = enrichedLocation;
      }
      
      return res.data;
    }
    return null;
  } catch (reason: any) {
    console.log("Position detail error:", reason.message);
    return null;
  }
}

export async function getRelatedInfo(
  positionId: string | number,
): Promise<any> {
  try {
    const mytoken = localStorage.getItem("token");
    const res = await axios.get(
      `${SERVICEURL}api/Position/GetRelatedInfo/${positionId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );
    return res.data;
  } catch (reason: any) {
    console.log("GetRelatedInfo error:", reason.message);
    return null;
  }
}

export async function addRelatedInfo(data: any): Promise<any> {
  try {
    const mytoken = localStorage.getItem("token");
    const res = await axios.post(
      `${SERVICEURL}api/Position/AddRelatedInfo`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );

    // Eğer response status 200-299 arasında değilse hata fırlat
    if (res.status < 200 || res.status >= 300) {
      throw new Error(`API Error: ${res.status}`);
    }

    // Eğer response data içinde error varsa hata fırlat
    if (res.data?.error || res.data?.isSuccess === false) {
      throw new Error(res.data?.message || "İşlem başarısız oldu");
    }

    return res.data;
  } catch (reason: any) {
    console.error("AddRelatedInfo error:", reason);
    throw reason;
  }
}

export async function addCustomerRelation(data: any): Promise<any> {
  try {
    const mytoken = localStorage.getItem("token");
    const res = await axios.post(
      `${SERVICEURL}api/Position/AddCustomerRelation`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );

    // Eğer response status 200-299 arasında değilse hata fırlat
    if (res.status < 200 || res.status >= 300) {
      throw new Error(`API Error: ${res.status}`);
    }

    // Eğer response data içinde error varsa hata fırlat
    if (res.data?.error || res.data?.isSuccess === false) {
      throw new Error(res.data?.message || "İşlem başarısız oldu");
    }

    return res.data;
  } catch (reason: any) {
    console.error("AddCustomerRelation error:", reason);
    throw reason;
  }
}

export async function deleteRelatedInfo(
  relatedId: string | number,
): Promise<any> {
  try {
    const mytoken = localStorage.getItem("token");
    const res = await axios.delete(
      `${SERVICEURL}api/Position/DeleteRelatedInfo/${relatedId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );
    return res.data;
  } catch (reason: any) {
    console.log("DeleteRelatedInfo error:", reason.message);
    throw reason;
  }
}

export async function getTeamsByCustomerId(
  customerID: string,
  employeeID: string,
): Promise<any[]> {
  try {
    const mytoken = localStorage.getItem("token");
    const res = await axios.get(
      `${SERVICEURL}api/Data/GetTeamsbyCustomerId/${customerID}`,
      {
        headers: {
          accept: "text/plain",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );
    if (Array.isArray(res.data?.data)) {
      return res.data.data;
    } else if (Array.isArray(res.data)) {
      return res.data;
    }
    return [];
  } catch (reason: any) {
    console.log("Teams List error:", reason.message);
    return [];
  }
}

export async function getIkPersonelList(): Promise<any[]> {
  try {
    const mytoken = localStorage.getItem("token");
    const res = await axios.get(
      `${SERVICEURL}api/Data/GetActiveIKPersonnelList`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );
    if (Array.isArray(res.data?.data)) {
      return res.data.data;
    } else if (Array.isArray(res.data)) {
      return res.data;
    }
    return [];
  } catch (reason: any) {
    console.log("IK List error:", reason.message);
    return [];
  }
}

export async function getCompanyList(): Promise<any[]> {
  try {
    const res = await axios.get(`${SERVICEURL}api/Data/GetCompanies`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${mytoken}`,
      },
    });
    if (Array.isArray(res.data?.data)) {
      return res.data.data;
    } else if (Array.isArray(res.data)) {
      return res.data;
    } else if (Array.isArray(res.data.companies)) {
      return res.data.companies;
    }
    return [];
  } catch (reason: any) {
    console.log("Handle else:", reason.message);
    return [];
  }
}

export async function createPosition(
  data: Partial<PositionData>,
): Promise<PositionData | null> {
  try {
    const res = await axios.post(API_BASE, data);
    return res.data;
  } catch {
    return null;
  }
}

export async function updatePosition(data: any): Promise<PositionData | null> {
  const mytoken = localStorage.getItem("token");
  try {
    const res = await axios.post(
      `${SERVICEURL}api/Position/UpdatePositionDetail`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );
    // Response bir dizi ise ilk elemanı, obje ise doğrudan döndür
    if (Array.isArray(res.data?.data)) {
      return res.data.data[0] || null;
    } else if (typeof res.data?.data === "object" && res.data?.data !== null) {
      return res.data.data;
    } else if (typeof res.data === "object" && res.data !== null) {
      return res.data;
    }
    return null;
  } catch (reason: any) {
    console.log("UpdatePosition error:", reason.message);
    return null;
  }
}

export async function getCustomerList(): Promise<any[]> {
  const mytoken = localStorage.getItem("token");
  try {
    const res = await axios.get(`${SERVICEURL}api/Data/GetCustomers`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${mytoken}`,
      },
    });
    if (Array.isArray(res.data?.data)) {
      return res.data.data;
    } else if (Array.isArray(res.data)) {
      return res.data;
    }
    return [];
  } catch (reason: any) {
    console.log("Customer List error:", reason.message);
    return [];
  }
}

export type AddRecruitersPositionStatsBody = {
  recruiterIds: string[];
  positionIds: string[];
  startDate: string;
  endDate: string;
};

export async function addRecruitersPositionStats(
  body: AddRecruitersPositionStatsBody,
): Promise<{ success: boolean; message: string }> {
  try {
    const mytoken = localStorage.getItem("token");
    const res = await axios.post(
      `${SERVICEURL}api/Position/AddRecruitersPositionStats`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );
    const code: number = res.data?.Code ?? res.data?.code ?? res.status;
    const message: string =
      res.data?.Message ?? res.data?.message ?? "";
    return { success: code === 200, message };
  } catch (reason: any) {
    const message: string =
      reason?.response?.data?.Message ??
      reason?.response?.data?.message ??
      reason?.message ??
      "Bilinmeyen hata";
    return { success: false, message };
  }
}

export type DeleteAllRecruiterFromPositionBody = {
  startDate: string;
  endDate: string;
};

export async function deleteAllRecruiterFromPosition(
  body: DeleteAllRecruiterFromPositionBody,
): Promise<{
  success: boolean;
  message: string;
}> {
  try {
    const mytoken = localStorage.getItem("token");
    const res = await axios.delete(
      `${SERVICEURL}api/Position/DeleteAllRecruiterFromPosition`,
      {
        // DELETE gövdesi axios'ta `data` ile gönderilir. BE karşılığı
        // [FromBody] DeleteRecruiterDataFromStatDTO { startDate, endDate }.
        data: body,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );
    const code: number = res.data?.Code ?? res.data?.code ?? res.status;
    const message: string =
      res.data?.Message ?? res.data?.message ?? "";
    return { success: code === 200, message };
  } catch (reason: any) {
    const message: string =
      reason?.response?.data?.Message ??
      reason?.response?.data?.message ??
      reason?.message ??
      "Bilinmeyen hata";
    return { success: false, message };
  }
}

export async function getRecruiterPositionStats(
  startDate: string,
  endDate: string,
): Promise<{ success: boolean; data: any[]; message: string }> {
  const fallbackMessage = "Pozisyon dağıtım verileri yüklenemedi.";
  try {
    const mytoken = localStorage.getItem("token");
    const res = await axios.get(
      `${SERVICEURL}api/Position/GetRecruiterPositionStats?startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );
    const code: number = res.data?.Code ?? res.data?.code ?? res.status;
    const message: string =
      res.data?.Message ?? res.data?.message ?? "";
    if (code !== 200) {
      return { success: false, data: [], message: message || fallbackMessage };
    }
    if (Array.isArray(res.data?.data?.data)) {
      return { success: true, data: res.data.data.data, message: "" };
    }
    if (Array.isArray(res.data?.data)) {
      return { success: true, data: res.data.data, message: "" };
    }
    return { success: true, data: [], message: "" };
  } catch (reason: any) {
    const message: string =
      reason?.response?.data?.Message ??
      reason?.response?.data?.message ??
      reason?.message ??
      fallbackMessage;
    console.log("GetRecruiterPositionStats error:", reason.message);
    return { success: false, data: [], message };
  }
}

export async function getCustomerListByCompanyId(
  companyId: string | number,
): Promise<any[]> {
  const mytoken = localStorage.getItem("token");
  try {
    const res = await axios.get(
      `${SERVICEURL}api/Data/GetCustomerListbyCompanyId/${companyId}`,
      {
        headers: {
          accept: "text/plain",
          Authorization: `Bearer ${mytoken}`,
        },
      },
    );

    if (Array.isArray(res.data?.data)) {
      return res.data.data;
    } else if (Array.isArray(res.data)) {
      return res.data;
    } else if (Array.isArray(res.data?.customers)) {
      return res.data.customers;
    }
    return [];
  } catch (reason: any) {
    console.log("Customer List by Company error:", reason.message);
    return [];
  }
}
